export const ALIGNMENT_EDIT_CLARIFICATION_TYPE = 'alignment_edit_clarification';
export const ALIGNMENT_EDIT_CUSTOM_PROMPT = '请输入调整意见，例如"分镜太密集了"或"角色不够丰富"';
